import React from "react";
import PropTypes from "prop-types";
import { Card, Button, message, Icon, Table, Select, Upload, Modal, Form, Input, Spin } from "antd";
import { List } from "immutable";
import { CaseService } from "services";
import CaseLeegalityService from "services/case-leegality-agreement-service"; 
import moment from "moment";
import { AGREEMENT_APPLICANT_DETAILS_COLS } from "../../constants/table-columns";
import { BASE_URL } from "constants";
import { getAuthToken } from "utilities/auth";
import { LeegalityTemplateDrawer } from "../leegality/leegality-home";
import QueryString from "query-string";

const { Option } = Select;

export default class EsignTab extends React.Component {
    state = {
        data: new List([]),
        html: "",
        pdf: null,
        loading: true,
        status: null,
        error: "",
        is_eligible: 1,
        is_audit_trail: 0,
        audit_trail: "",
        is_initiate_active: false,
        is_signed_document: false,
        signed_document: "",
        urls: [],
        isUrlsModalVisibile: false,
        openRetriggerModal: false,
        doc: 1,
        adhocAmount: "",
        language: "",
        witness: "",
        agreementApplicantData: [],
        last_updated: "",
        total_associate: "",
        risk_sharing_percentage:"",
        logs_data: [],
        languageList: [],
        witnessList: [],
        esignData: [],
        distributorAgreementModal: false,
        distributor_gstin: null,
        industry: null,
        program_size_cr: null,
        retailer_data: null,
        fileName: null,
        templateData: {},
        loading : false,
        legality_data : {}
    }

    retriggerReason = null;

    componentDidMount() {
        this.getEsignAgreementData(this.props.profile && this.props.profile.toJS().data.gstin, 1, 0);
    }

    getEsignAgreementData = (gstin, document_id, refresh, mpa_approval_id = undefined) => {
        this.setState({
            loading : true
        })
        CaseLeegalityService.getEsignAgreementData(gstin, document_id, refresh, this.state.legality_data, mpa_approval_id).then((data) => {
            this.stopLoader()
            if(Object.keys(data).length){
                this.setState({
                    esignData: data,
                    agreementApplicantData: data.data.data.applicants_details,
                    status: data.data.data.status,
                    last_updated: data.data.data.last_updated,
                    total_associate: data.data.data.applicants_details.length,
                    risk_sharing_percentage:data.data.data.risk_sharing_percentage,
                    legality_data: data.data.data
                });
            }               
           
        })
        .catch((err) => {
            this.stopLoader();
        });
    }

    getAgreementData = (caseId, docId, refresh) => {

        CaseLeegalityService.getCaseAgreementData(caseId, docId, refresh).then((data) => {
            this.setState({
                agreementApplicantData: data.data.data.applicants_details,
                last_updated: data.data.data.last_updated,
                status: data.data.data.status,
                total_associate: data.data.data.total_associate,
                logs_data: data.data.data.logs,
                signed_document: data.data.data.signed_document,
                languageList: data.data.data.document_type_detail.language,
                witnessList: data.data.data.document_type_detail.witeness
            });
        });
    }

    triggerAgreement = (preview = false) => {
        this.setState({
            loading : true
        })
        var payload = {};
        if(this.state.doc === 1){
            payload = {
                document_id: 1,
                data: {
                    distributor_gstin: this.props.profile.toJS().data.gstin,
                    retailer_data: this.state.retailer_data,
                    all_cases: true
                }
            };
            try {
                message.loading("Triggering Agreement please wait...");
                /* eslint-disable */
                let hitSignzy = false;
                CaseService.postEsignAgreement(payload, hitSignzy).then(({ data }) => {
                    this.getEsignAgreementData(this.props.profile.toJS().data.gstin, this.state.doc, 0);
                    this.stopLoader()
                    this.setState({
                        templateData: {
                            ...data,
                            document_id: 1,
                            distributor_gstin: this.props.profile.toJS().data.gstin
                        },
                        isVisible:  hitSignzy,
                        fileName: null,
                        industry: null,
                        program_size_cr: null
                    });
                }).catch((err) => {
                    console.error(err);
                    this.stopLoader()

                });
            } catch (e) {
                this.stopLoader()
                message.error("Error in triggering");
            }
        } else if([2,6,7].includes(this.state.doc)){
            payload = {
                document_id: this.state.doc,
                preview: preview,
                data: {
                    distributor_gstin: this.props.profile.toJS().data.gstin,
                    industry: this.state.industry,
                    program_size_cr: this.state.program_size_cr
                }
            }
            try {
                message.loading("Triggering Agreement please wait...");
                /* eslint-disable */
                let hitSignzy = [6,7].includes(this.state.doc);
                CaseService.postEsignAgreement(payload, hitSignzy).then(({ data }) => {
                    this.stopLoader()
                    if (!preview){
                        this.getEsignAgreementData(this.props.profile.toJS().data.gstin, this.state.doc, 0);
                    }
                    this.setState({
                        templateData: {
                            ...(Boolean(preview) ? data.data : data),
                            document_id: this.state.doc,
                            distributor_gstin: this.props.profile.toJS().data.gstin
                        },
                        isVisible: hitSignzy || preview,    
                        fileName: null,
                        industry: null,
                        program_size_cr: null
                    });
                }).catch((err) => {
                    message.error(err?.error || "Error in triggering")
                    this.stopLoader()
                    console.error(err);
                });
            } catch (e) {
                message.error(e || "Error in triggering")
                this.stopLoader()
            }
        }
    }

    onChangeDoc = (value) => {
        const searchParams = QueryString.parse(window.location.search);

        if(value === 2){
            this.setState({
                distributorAgreementModal: true,
                distributor_gstin: null,
                program_size_cr: null,
                industry: null
            })
        }
        if(searchParams.mpa_id){
            this.getEsignAgreementData(this.props.profile.toJS().data.gstin, value, 0, searchParams.mpa_id);

        }else{
            this.getEsignAgreementData(this.props.profile.toJS().data.gstin, value, 0);
        }
        this.setState({
            doc: value,
            fileName: null
        });
    }

    stopLoader = () => {
        this.setState({
            loading: false
        })
    }

    onCopyUrl = (a, record, c) => {
        var input = document.body.appendChild(document.createElement("input"));
        input.value = record.sign_url;
        input.focus();
        input.select();
        document.execCommand('copy');
        input.parentNode.removeChild(input);
        message.success("URL copied");
    }

    TableCellClick = (clickHandler, label) => (columnValue, record) => {
        return (<a onClick={clickHandler.bind(null, columnValue, record)}>{label}</a>);
    }

    TableCellCopyUrl = (clickHandler) => (columnValue, record) => {
        return (
            <span onClick={clickHandler.bind(null, columnValue, record)}>
                <Icon style={{ fontSize: '20px', cursor: "pointer" }} type="copy" />
            </span>
        );
    }

    onFinish = (values) => {
        console.log('Success:', values);
      };
    
    onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    };

    onDistAgreSubmit(){
        this.setState({
            distributorAgreementModal: false
        });
        message.success("Data Successfully Saved");
    }

    refreshList (){
        message.loading("Refreshing");
        this.getEsignAgreementData(this.props.profile && this.props.profile.toJS().data.gstin, this.state.doc, 1)
    }

    handleEsignDrawer = (refresh) => {
        if(this.state.isVisible){
            this.getEsignAgreementData(this.props.profile.toJS().data.gstin, this.state.doc, 1);
        }
        this.setState({
            isVisible : !this.state.isVisible,
            templateData: {}
        })
    }

    deleteRequest = () => {
        // try {
        //     /* eslint-disable */
        // CaseLeegalityService.getEsignAgreementData(gstin, document_id, refresh).then((data) => {
        //     message.success("Agreement request deleted");
        //     this.setState({
        //         esignData: data,
        //         agreementApplicantData: data.data.data.applicants_details,
        //         status: data.data.data.status,
        //         last_updated: data.data.data.last_updated,
        //         total_associate: data.data.data.applicants_details.length
        //     });
        // });
            message.loading("Deleting request please wait...");
            this.setState({
                loading: true
            })
            try{
                CaseLeegalityService.deleteEsignAgreementData(this.props.companyId, this.state.doc , this.state.legality_data.document_id).then(()=> {
                    message.success("Agreement deleted");
                    this.getEsignAgreementData(this.props.profile && this.props.profile.toJS().data.gstin, this.state.doc, 1);
    
                })
                .catch(({error}) => {
                    message.error(error.code || "Error in Deleting");
                   this.stopLoader()
                });
            }
            catch (e) {
                message.error("Error in Deleting");
                this.stopLoader()
            }
        // } catch (e) {
        //     message.error("Error in deleting request");
        // }
    }


    render() {
        const { 
            doc,
            status, 
            last_updated, 
            total_associate,
            risk_sharing_percentage,
        } = this.state;

        var AGREE_COLS = AGREEMENT_APPLICANT_DETAILS_COLS.filter((key, value) => value !== "action");
        
        AGREE_COLS = AGREE_COLS.map((col, key) => {
            if(key === "copy"){
                return Object.assign({
                    render: this.TableCellCopyUrl(this.onCopyUrl)
                }, col);
            }
            return col;
        });
        return (
            <Spin spinning={this.state.loading}>
                <div className={"p-10"}>
                    <LeegalityTemplateDrawer 
                        showTriggerButton={this.state.doc == 2 ? false : true}
                        companyId={this.props.companyId}
                        isVisible={this.state.isVisible}
                        templateData={this.state.templateData}
                        handleEsignDrawer={this.handleEsignDrawer}
                        dbAgreement={true}
                    />
                    {this.state.is_eligible ? <div
                        style={{
                            paddingBottom: "30px",
                            background: "#eceff1",
                        }}
                    >
                        <Card
                            style={{
                                padding: "50px",
                                paddingBottom: "30px",
                            }}
                        >
                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <div
                                    style={{
                                        display: "flex",
                                        flex: 1,
                                        alignContent: "flex-start",
                                        flexDirection: "column",
                                        lineHeight: "14px"
                                    }}
                                >
                                    <div>
                                        <span 
                                            style={{
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Total Associates : {total_associate ? total_associate : "0"}
                                        </span>
                                         <span 
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            marginLeft: "20px",
                                        }}
                                    >
                                      Gaurantee: {risk_sharing_percentage ? risk_sharing_percentage + "%" : "0%"}
                                    </span>
                                    </div>
                                    <div>
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                fontWeight: "normal",
                                            }}
                                        >
                                            Last Updated at <span style={{color: "#16c79a"}}>{moment(last_updated).format("MMM Do YYYY")}</span>
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <div
                                        style={{
                                            lineHeight: "14px"
                                        }}
                                    >
                                        <span 
                                            style={{
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Status: <span>{status} </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div style={{marginTop: "10px"}}>
                            <div className={" mt-5 mr-15 d-flex"} style={{justifyContent: "flex-start"}}>
                                    <div>
                                        <Select
                                            style={{ 
                                                width: 200,
                                                marginRight: "20px" 
                                            }}
                                            placeholder="Select"
                                            optionFilterProp="children"
                                            defaultValue={1}
                                            onChange={this.onChangeDoc}
                                            filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            <Option value={1}>Recommendation</Option>
                                            <Option value={2}>Distributor Agreement</Option>
                                            <Option value={6}>Samsung DB MoU- Revised Dec'23</Option>
                                            <Option value={7}>50:50 Risk sharing with Churns</Option>
                                            <Option value={""}>Anchor Agreement</Option>
                                        </Select>
                                    </div>
                                    {
                                        doc === 1 ? 
                                            <Upload
                                                key={"Upload File"}
                                                {...{
                                                    directory: false, // Upload Directory Support
                                                    multiple: true, // Upload Multiple files support,
                                                    action:
                                                        `${BASE_URL}/company/upload_file/`,
                                                    showUploadList: false,
                                                    headers: {
                                                        Authorization: `Bearer ${getAuthToken().authToken
                                                            }`
                                                    },
                                                    data: file => {
                                                        message.loading("Uploading File...", 0);
                                                    },
                                                    onChange: ({ file }) => {
                                                        if (file.status === "done") {
                                                            message.destroy();
                                                            message.success(`${file.name} Uploaded`);
                                                            this.setState({
                                                                retailer_data: file.response,
                                                                fileName: file.name
                                                            });
                                                        }
                                                        if (file.status === "error") {
                                                            message.destroy();
                                                            message.error(`Failed to Upload ${file.name}`);
                                                            this.setState({
                                                                fileName: null
                                                            })
                                                        }
                                                    }
                                                }}
                                            ><Button>Click to Upload <Icon type="upload" style={{cursor: "pointer"}} /></Button></Upload> : null
                                    }
                                    {
                                        this.state.fileName ? <span style={{padding: "10px"}}>{this.state.fileName}</span>:null
                                    }
                                </div>
                                <div className={"mt-5 mr-15 d-flex"} style={{justifyContent: "flex-start"}}>
                                    {
                                        // [2,6,7].includes(doc) && this.props.permissions.get('db_mou_trigger') ? 
                                            // <Button 
                                            //     disabled={status === "Initiated"}
                                            //     type="primary" 
                                            //     icon="fire"    
                                            //     style={{ 
                                            //         background: "#16c79a", 
                                            //         borderColor: "#16c79a", 
                                            //         margin: "10px",
                                            //         marginLeft: "0px" 
                                            //     }}
                                            //     onClick={() => this.triggerAgreement(false)}
                                            // >
                                            //     {status === "Initiated" ? "Re-Trigger" : "Trigger"}
                                            // </Button>
                                            // : null
                                    }
                                    {
                                        // this.props.permissions.get('db_mou_trigger') && doc === 1 ? 
                                        //     <Button 
                                        //         type="primary" 
                                        //         icon="fire"  
                                        //         style={{ 
                                        //             background: "#16c79a", 
                                        //             borderColor: "#16c79a", 
                                        //             margin: "10px",
                                        //             marginLeft: "0px"
                                        //         }}
                                        //         disabled={status === "Initiated"}
                                        //         onClick={() => this.triggerAgreement(false)}
                                        //     >
                                        //         {status === "Initiated" ? "Re-Trigger" : "Trigger"}
                                        //     </Button>
                                        //     : null
                                    }
                                    {/* {doc != "" &&  this.props.permissions.get('db_mou_trigger') && <Button
                                        onClick={this.deleteRequest}
                                        type="primary" 
                                        icon="delete" 
                                        style={{ 
                                            background: "#16c79a", 
                                            borderColor: "#16c79a", 
                                            margin: "10px" 
                                        }}
                                        disabled={status != "Initiated"}
                                    >
                                        Delete Request
                                    </Button>} */}
                                    <Button 
                                        type="primary" 
                                        // disabled={true} 
                                        icon={"download"} 
                                        style={{ 
                                            background: "#16c79a", 
                                            borderColor: "#16c79a", 
                                            margin: "10px" 
                                        }}
                                        disabled={!this.state.legality_data.signed_document}
                                    >
                                        <a href={this.state.legality_data.signed_document} target="_blank" download > <span style={{color: "#fff!important", marginLeft: "5px"}}>Download Signed Document</span></a>
                                     </Button>
                                    {/* {this.state.doc == 2 && <Button
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }}
                                    onClick={() => this.triggerAgreement(true)}
                                    >Preview</Button>} */}
                                   
                                </div>
                            </div>
                        </Card>
                        <div style={{padding: "20px"}}>
                            <Card
                                style={{
                                    borderRadius: "5px"
                                }}
                            >
                                <div>
                                    <div style={{display: "inline-flex", width: "100%"}}>
                                        <div style={{
                                            marginTop: "20px",
                                            marginBottom: "20px",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            width: "50%"
                                        }}>
                                            Applicant's Details
                                        </div>
                                        <div style={{
                                            marginTop: "20px",
                                            marginBottom: "20px",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            textAlign: "right",
                                            width: "50%"
                                        }}>
                                            <a 
                                            className={status == "Yet to Initiate" ? "disabled" : ""} 
                                            disabled={status == "Yet to Initiate"} onClick={() => this.refreshList()}>Refresh</a>
                                        </div>
                                    </div>
                                    <Table 
                                        style={{border: "1px solid #e8e8e8"}} 
                                        columns={AGREE_COLS} 
                                        dataSource={this.state.agreementApplicantData}
                                        pagination={false} 
                                    />
                                </div> 
                            </Card>
                        </div>
                    </div>
                    :   <div className={"d-flex justify-content-center"}>
                            <Icon className={"mr-5"} type={"exclamation-circle"} style={{ color: "red", fontSize: 18 }} />
                            <h2 style={{
                                textAlign: "center"
                            }}>{this.state.error}</h2>
                        </div>}
                </div>
            </Spin>
        );
    }
}

EsignTab.propTypes = {
    history: PropTypes.object,
    permissionContext: PropTypes.object,
    caseId: PropTypes.number,
    stageId: PropTypes.number,
    caseDetail: PropTypes.object,
    company: PropTypes.object,
    companyDetails: PropTypes.object,
    profile: PropTypes.object,
    permissions: PropTypes.object
};